export default __webpack_public_path__ + "static/media/visual-testing.ac709621.svg";